import { render } from "./LoadingComp.vue?vue&type=template&id=5d178ea9&scoped=true"
import script from "./LoadingComp.vue?vue&type=script&lang=js"
export * from "./LoadingComp.vue?vue&type=script&lang=js"

import "./LoadingComp.vue?vue&type=style&index=0&id=5d178ea9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d178ea9"]])

export default __exports__